import createIcon from '../../createIcon';

/**
 * @component @name PartyMode
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNUgxNi44M0wxNSAzSDlMNy4xNyA1SDRDMi45IDUgMiA1LjkgMiA3VjE5QzIgMjAuMSAyLjkgMjEgNCAyMUgyMEMyMS4xIDIxIDIyIDIwLjEgMjIgMTlWN0MyMiA1LjkgMjEuMSA1IDIwIDVaTTEyIDhDMTMuNjMgOCAxNS4wNiA4Ljc5IDE1Ljk4IDEwSDEyQzEwLjM0IDEwIDkgMTEuMzQgOSAxM0M5IDEzLjM1IDkuMDcgMTMuNjkgOS4xOCAxNEg3LjFDNy4wNCAxMy42OCA3IDEzLjM0IDcgMTNDNyAxMC4yNCA5LjI0IDggMTIgOFpNMTIgMThDMTAuMzcgMTggOC45NCAxNy4yMSA4LjAyIDE2SDEyQzEzLjY2IDE2IDE1IDE0LjY2IDE1IDEzQzE1IDEyLjY1IDE0LjkzIDEyLjMxIDE0LjgyIDEySDE2LjlDMTYuOTcgMTIuMzIgMTcgMTIuNjYgMTcgMTNDMTcgMTUuNzYgMTQuNzYgMTggMTIgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PartyMode = createIcon('PartyMode', [
  [
    'path',
    {
      d: 'M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM12 8C13.63 8 15.06 8.79 15.98 10H12C10.34 10 9 11.34 9 13C9 13.35 9.07 13.69 9.18 14H7.1C7.04 13.68 7 13.34 7 13C7 10.24 9.24 8 12 8ZM12 18C10.37 18 8.94 17.21 8.02 16H12C13.66 16 15 14.66 15 13C15 12.65 14.93 12.31 14.82 12H16.9C16.97 12.32 17 12.66 17 13C17 15.76 14.76 18 12 18Z',
      key: 'wyordy',
    },
  ],
]);

export default PartyMode;
